import { createGlobalStyle } from 'styled-components/macro';

const GlobalStyle = createGlobalStyle`
  body, html, #root {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    text-rendering: geometricPrecision;
  }
  
  *:focus {
    outline: none;
  }

  * {
    box-sizing: border-box;
  }

  body.dragging: {
    cursor: grabbing !important;
 }

 .connection {
  position: static !important;
}


`;

export default GlobalStyle;
